import styled from 'styled-components';
import media from './MediaQueries';

const StyledButton = styled.button`
  cursor: pointer;
  display: flex;
  align-items: center;
  width: 200px;
  height: 60px;
  border-radius: 4px;
  background-color: white;
  margin-bottom: 3vh;
  color: black;
  font-size: 14px;
  font-weight: 400;
  box-shadow: 0 4px 12px rgba(0,0,0,.12);
  transition: transform .35s cubic-bezier(.5,0,0,1),
              border .35s cubic-bezier(.5,0,0,1);

  transform: ${props => props.selected ? 'scale3d(1.1, 1.1, 1.0)' : 'scale3d(1.0, 1.0, 1.0)'};
  border: ${props => props.selected ? '3px solid #FFAA5F' : '3px solid transparent'};
  justify-content: ${props => props.align ? props.align : 'center'};

  ${media.phone`
    flex: 1 1 auto;
    max-width: 45%;
    height: 60px;
    margin: 0 5px 15px 5px;
  `}

  ${media.smphone`
    font-size: 12px;
    font-weight: 500;
  `}

  .tone {
    height: 24px;
    width: 24px;
    border-radius: 50%;
    border: 2px solid #FBFBFB;
    margin: 0 16px 0 20px;
    ${media.phone`
      margin: 0 10px 0 10px;
    `}
    ${media.smphone`
      height: 16px;
      width: 16px;
    `}
  }

  .colorIcon_light {
    background-color: #EFD2B5;
  }

  .colorIcon_fair {
    background-color: #DFB594;
  }

  .colorIcon_medium {
    background-color: #CAA081;
  }

  .colorIcon_olive {
    background-color: #B17A57;
  }

  .colorIcon_brown {
    background-color: #9B6037;
  }

  .colorIcon_darkbrown {
    background-color: #39221E;
  }
`

export default StyledButton;


// WEBPACK FOOTER //
// ./src/components/instore/MainButton.style.js